// @ts-nocheck
/* eslint-disable */
module.exports = {
  languageData: {
  "plurals": function (n, ord) {
    if (ord) return "other";
    return n == 1 ? "one" : "other";
  }
},
  messages: {
    "(Name of your language) translation": "Traducci\xF3n en espa\xF1ol",
    "(Note: the email will be sent in English)": "(Nota: tenga en cuenta que el correo electr\xF3nico se enviar\xE1 en ingl\xE9s)",
    "(optional)": "(opcional)",
    "<0/> makes use of a <1/> and <2/>, which you can review.": "<0/> usa una <1/> y unos <2/>, que puedes revisar.",
    "<0>Free tools for you to fight for a safe and healthy home</0><1>Enter your address to learn more.</1>": "<0>Herramientas gratuitas para luchar por un hogar seguro y saludable</0><1>Introduce tu direcci\xF3n para saber m\xE1s.</1>",
    "<0>Know the Risks:</0> If you aren't sure about your regulated status, you may want to do more research before using our tools. Non-regulated tenants have fewer protections against eviction and larger rent increases than regulated tenants. <1>Learn more here</1>.": "<0>Conoce los riesgos:</0> si no est\xE1s seguro de tu situaci\xF3n regulada, es posible que desees investigar m\xE1s antes de utilizar nuestras herramientas. Los inquilinos no regulados tienen menos protecciones contra el desalojo y aumentos de alquiler m\xE1s elevados que los inquilinos regulados. <1>Obt\xE9n m\xE1s informaci\xF3n aqu\xED</1>.",
    "<0>Know the Risks:</0> Market tenants have fewer protections against eviction and larger rent increases than rent regulated tenants.": "<0>Conoce los riesgos:</0> los inquilinos del mercado tienen menos protecciones contra el desalojo y aumentos de alquiler m\xE1s elevados que los inquilinos con alquiler regulado.",
    "<0>Note:</0> your information will also be shared with our partner organization <1>{name}</1>. If you don't want this, you can click the \"Cancel\" button above and start this process over.": function (a) {
  return ["<0>Nota:</0> tu informaci\xF3n tambi\xE9n se compartir\xE1 con nuestra organizaci\xF3n asociada <1>", a("name"), "</1>. Si no deseas que esto ocurra, puedes hacer clic en el bot\xF3n \xABCancelar\xBB situado arriba y volver a iniciar el proceso."];
},
    "<0>To</0><1/><2>From</2><3/>": "<0>De</0><1/><2>Hasta</2><3/>",
    "About": "Acerca de",
    "About you": "Sobre usted",
    "Account settings": "Detalles de la cuenta",
    "Actions": "Acciones",
    "Add issues": "A\xF1adir problemas",
    "Add or remove issues": "A\xF1adir o eliminar n\xFAmeros de revista",
    "Address": "Direcci\xF3n",
    "Affordable housing (other than rent-stabilized)": "Vivienda asequible (distinta de la vivienda de renta estabilizada)",
    "After this step, you cannot go back to make changes. But don’t worry, we’ll explain what to do next.": "Despu\xE9s de este paso, no puedes volver a hacer cambios. Pero no te preocupes, te explicaremos qu\xE9 hacer despu\xE9s de enviar la carta.",
    "Alabama": "Alabama",
    "Alas.": "Mecachis.",
    "Alaska": "Alaska",
    "All apartments in buildings that receive a tax abatement such as J-51, 421a, and 421g are also stabilized.": "Todos los apartamentos de los edificios que se benefician de una reducci\xF3n fiscal, como J-51, 421a y 421g, tambi\xE9n est\xE1n estabilizados.",
    "Apartment needs painting": "El apartamento necesita pintura",
    "Apartment number": "N\xFAmero de apartamento",
    "Are you sure you want to log out?": "\xBFEst\xE1s seguro de que quieres cerrar la sesi\xF3n?",
    "Are you sure you want to proceed with the following address?": "\xBFSeguro que quieres continuar con la siguiente direcci\xF3n?",
    "Are you sure you want to sign out, {displayName}?": function (a) {
  return ["\xBFEst\xE1s seguro de que quieres cerrar sesi\xF3n, ", a("displayName"), "?"];
},
    "Arizona": "Arizona",
    "Arkansas": "Arkansas",
    "Back": "Atr\xE1s",
    "Back door": "Puerta trasera",
    "Baseboards defective": "Z\xF3calo defectuoso",
    "Bathroom": "Ba\xF1o",
    "Bathrooms": "Ba\xF1os",
    "Bathtub": "Ba\xF1era",
    "Bathtub: cracked tub": "Ba\xF1era: agrietada",
    "Bathtub: drain stoppage": "Ba\xF1era: desag\xFCe atascado",
    "Bathtub: faucets not installed": "Ba\xF1era: no hay grifo",
    "Bathtub: faucets not working": "Ba\xF1era: grifo no funciona",
    "Bathtub: leaky faucet": "Ba\xF1era: grifo con fugas",
    "Bathtub: pipes leaking": "Ba\xF1era: tuber\xEDas con fugas",
    "Bedroom": "Rec\xE1mara",
    "Bedrooms": "Rec\xE1maras",
    "Broken": "Quebrado",
    "Broken elevator": "Elevador roto",
    "Broken/defective windows": "Ventanas quebradas/defectuosas",
    "Broken/insecure locks": "Seguros quebrados/defectuosos",
    "Broken/no smoke/Co2 detector": "Sin detector de Co2 o humo",
    "Bug infestation": "Infestaci\xF3n de insectos",
    "Bug infestation (roaches, bedbugs, ... )": "Infecci\xF3n de bichos (cucarachas, chinches, ... )",
    "Build my letter": "Crear mi carta",
    "Build your letter": "Crea tu carta",
    "Building and safety": "Construcci\xF3n y seguridad",
    "Building exit": "Salida del edificio",
    "Building main entrance": "Entrada principal del edificio",
    "Building parking entrance": "Entrada de estacionamiento del edificio",
    "Building-wide": "En todo el edificio",
    "Buildings in your landlord's portfolio are located in {0, plural, one {one zip code.} other {# zip codes.}}": function (a) {
  return ["Los edificios en el portafolio del due\xF1o de tu edificio se encuentran en ", a("0", "plural", {
    one: "un c\xF3digo postal.",
    other: ["#", " c\xF3digo postales."]
  })];
},
    "Buzzer not working": "El timbre del edificio no funciona",
    "California": "California",
    "Can't pay rent?": "\xBFNo puedes pagar la renta?",
    "Cancel": "Cancelar",
    "Cancel and go back": "Cancelar y volver atr\xE1s",
    "Ceiling falling/fell": "Techo colapsado/se colapsa",
    "Ceiling leaking": "Techo gotea",
    "Change": "Cambiar",
    "Change city and state from {cityAndState}": function (a) {
  return ["Cambiar ciudad y estado de ", a("cityAndState")];
},
    "City": "Ciudad",
    "City and state": "Ciudad y estado",
    "City/township/borough": "Ciudad/pueblo/municipalidad",
    "Click here to learn more about our privacy policy.": "Haga clic aqu\xED para obtener m\xE1s informaci\xF3n sobre nuestra pol\xEDtica de privacidad.",
    "Cockroaches": "Cucarachas",
    "Colorado": "Colorado",
    "Common areas (parking, hallway, etc.)": "\xC1reas comunes (estacionamiento, pasillo, etc)",
    "Confirm": "Confirmar",
    "Confirm your new password": "Confirma tu nueva contrase\xF1a",
    "Confirming the address": "Confirmando la direcci\xF3n",
    "Confirming the city": "Confirmando la ciudad",
    "Connecticut": "Connecticut",
    "Contact": "Contacta",
    "Contact a lawyer if your landlord retaliates": "Ponte en contacto con un abogado si el due\xF1o de tu edificio toma represalias",
    "Contact information": "Informaci\xF3n de contacto",
    "Continue": "Continuar",
    "Cracked sink": "Lavabo agrietado",
    "Cracked walls": "Paredes Agrietadas",
    "Create a password": "Crea una contrase\xF1a",
    "Create an Account": "Crear una cuenta",
    "Create an account to get started with your {actionLabel}!": function (a) {
  return ["\xA1Crea una cuenta para empezar a utilizar tu ", a("actionLabel"), "!"];
},
    "Dear <0/>,": "Estimado/a <0/>,",
    "Defective electricity": "Electricidad defectuosa",
    "Defective plumbing": "Plomer\xEDa defectuosa",
    "Delaware": "Delaware",
    "Developed with <0>Law Help Interactive</0>": "Desarrollado con <0>Law Help Interactive</0>",
    "Dining room": "Comedor",
    "District of Columbia": "Distrito de Columbia",
    "Do you live in {0}, {1}?": function (a) {
  return ["\xBFVives en ", a("0"), ", ", a("1"), "?"];
},
    "Do you receive a housing voucher or subsidy (Section 8 Voucher, FHEPS, CITYFHEPS, HASA, etc.)?": "\xBFRecibes alg\xFAn vale o subsidio para la vivienda (vale de la Secci\xF3n 8, FHEPS, CITYFHEPS, HASA, etc.)?",
    "Do you still want to mail to:": "\xBFA\xFAn deseas continuar?",
    "Don't have an account yet? You can sign up for one by composing a <0>Letter of Complaint</0>!": "\xBFA\xFAn no tienes una cuenta? \xA1Puedes registrarte redactando una <0>Carta de Queja</0>!",
    "Don't know what type of housing you live in?": "\xBFNo sabes en qu\xE9 tipo de vivienda vives?",
    "Don’t worry, we’ll save your progress so you’ll be able to come back to your last step when you log back in.": "No te preocupes, guardaremos tus respuestas para que puedas empezar desde donde te quedaste cuando vuelvas a conectarte.",
    "Door lock not working": "Cerradura de la puerta no funciona",
    "Door not working": "Puerta no funciona",
    "Doorbell not working": "El timbre de la casa no funciona",
    "Download letter": "Descargar la carta",
    "Drain stoppage": "Desag\xFCe atascado",
    "Dryer not working": "Secadora no funciona",
    "Edit": "Editar",
    "Either Rent Stabilized or Rent Controlled (legacy option)": "Alquiler estabilizado o alquiler controlado (opci\xF3n heredada)",
    "Electric wiring exposed": "Alambrado El\xE9ctrico Expuesto",
    "Electricity": "Electricidad",
    "Electricity not working": "La electricidad no funciona",
    "Email address": "Correo electr\xF3nico",
    "Email address for recipient #{recipientNum}": function (a) {
  return ["Direcci\xF3n de correo electr\xF3nico del destinatario #", a("recipientNum")];
},
    "Email {noun}": function (a) {
  return ["Correo electr\xF3nico ", a("noun")];
},
    "Emergency HP Action": "Acci\xF3n HP de Emergencia",
    "English version": "Versi\xF3n en ingl\xE9s",
    "Enter your address to see some recommended actions.": "Introduce tu direcci\xF3n para ver algunas acciones recomendadas.",
    "Eviction free": "Sin desahucio",
    "FAQs": "Preguntas Frecuentes",
    "Faqs": "Preguntas frecuentes",
    "Faucets not installed": "Grifos No Instalados",
    "Faucets not working": "Grifos No Funcionan",
    "Faulty doors": "Puerta defectuosa",
    "Federally-funded affordable housing developments owned by the government.": "Promociones inmobiliarias asequibles financiadas con fondos federales y propiedad del gobierno.",
    "Floor level": "Nivel de piso",
    "Floor sags": "Piso hundido",
    "Florida": "Florida",
    "For additional support with mold, moisture, and leak repair issues, contact the independent court-ordered Ombudsperson's Call Center at <0>1-888-341-7152</0> or <1>ombnyc.com</1>": "Para obtener ayuda adicional con problemas de moho, humedad y reparaci\xF3n de fugas, comun\xEDcate con el centro de atenci\xF3n telef\xF3nica independiente del Defensor del Pueblo designado por orden judicial al <0>1-888-341-7152</0> o visita <1>ombnyc.com</1>.",
    "For example, Section 8 Voucher, FHEPS, CITYFHEPS, HASA, etc.": "Por ejemplo, vale de la Secci\xF3n 8, FHEPS, CITYFHEPS, HASA, etc.",
    "Frequently Asked Questions": "Preguntas Frecuentes",
    "Front door": "Puerta principal",
    "Front door not working": "Puerta principal no funciona",
    "Fumes/smoke entering apartment": "Vapores/Humo Entrando en Casa",
    "Gas": "Gas",
    "General": "General",
    "Georgia": "Georgia",
    "Go back": "Atr\xE1s",
    "Good news! As a rent regulated tenant, you likely have extra protections against retaliation. Want to find out if you're being overcharged? Order your rent history <0>here</0>!": "\xA1Buenas noticias! Como inquilino con alquiler regulado, es probable que cuentes con protecciones adicionales contra represalias. \xBFQuieres saber si te est\xE1n cobrando de m\xE1s? \xA1Solicita tu historial de alquiler <0>aqu\xED</0>!",
    "Got it": "Entendido",
    "Got it!": "\xA1Entendido!",
    "Got it! We're sending your {noun} to {0}.": function (a) {
  return ["\xA1Entendido! Estamos enviando tu ", a("noun"), " a ", a("0"), "."];
},
    "Got it, take me there": "Entendido, ll\xE9vame",
    "HP Action": "Acci\xF3n HP",
    "Habitability (CA)": "Habitabilidad (CA)",
    "Hallway": "Pasillo",
    "Harassment (CA)": "Acoso (CA)",
    "Harassment (LA City/TAHO)": "Acoso (Ciudad de Los \xC1ngeles/TAHO)",
    "Have you previously called 311 with no results?": "\xBFHas llamado anteriormente al 311 sin obtener resultados?",
    "Having trouble logging in?": "\xBFTienes problemas para iniciar sesi\xF3n?",
    "Hawaii": "Hawaii",
    "Health": "Salud",
    "Hello world": "Hola mundo",
    "Help": "Ayuda",
    "Holes": "Agujeros",
    "Home self-inspection": "Autoinspecci\xF3n en casa",
    "Home-wide": "En toda la casa",
    "Homepage": "P\xE1gina Principal",
    "Hooray! The final step is to provide us with a new password.": "\xA1Hurra! El \xFAltimo paso es proporcionarnos una nueva contrase\xF1a.",
    "Housing in buildings built before January 1, 1974 with six or more units, including Single Room Occupancy (\"SRO\") hotels and rooming houses.": "Viviendas en edificios construidos antes del 1 de enero de 1974 con seis o m\xE1s unidades, incluidos hoteles de habitaciones individuales (\xABSRO\xBB) y pensiones.",
    "Housing type": "Tipo de vivienda",
    "Housing voucher?": "\xBFBono de vivienda?",
    "How do you protect my personal information?": "\xBFC\xF3mo protegen mis datos personales?",
    "How it works": "C\xF3mo funciona",
    "How to report mold issues through NYCHA's <0>Mold Busters program.</0>": "C\xF3mo informar sobre problemas de moho a trav\xE9s <0>del programa Mold Busters</0> de la NYCHA.",
    "I agree to the <0/> terms and conditions.": "Acepto los t\xE9rminos y condiciones de <0/>.",
    "I agree to the <0>JustFix terms and conditions</0>.": "Acepto los <0>t\xE9rminos y condiciones de JustFix</0>.",
    "I don't have a lease": "No tengo un arrendamiento",
    "I forgot my password": "He perdido mi contrase\xF1a",
    "I have no apartment number": "No tengo ning\xFAn n\xFAmero de apartamento",
    "I understand the risk": "Comprendo el riesgo",
    "I'm not sure": "No estoy seguro",
    "Idaho": "Idaho",
    "If you didn't receive a code, try checking your email. If it's not in there either, please email <0/>.": "Si no recibiste un c\xF3digo, comprueba tu correo electr\xF3nico. Si no lo encuentras, por favor env\xEDa un correo electr\xF3nico a <0/>.",
    "If you have trouble logging in, you can <0>reset your password</0>.": "Si tienes problemas para iniciar sesi\xF3n, puedes <0>restablecer tu contrase\xF1a</0>.",
    "If you need to make changes to your name or contact information, please contact <0/>.": "Si necesitas cambiar tu nombre o tu informaci\xF3n de contacto, ponte en contacto con <0/>.",
    "If you remember your password, you can <0>sign into your account</0>.": "Si recuerdas tu contrase\xF1a, puedes <0>iniciar sesi\xF3n en tu cuenta</0>.",
    "If you write checks or transfer money through your bank to pay your rent, use that name here.": "Usa el nombre al que pagas la renta.",
    "If you're having trouble logging in, we can reset your password. In order to do that, we'll need your phone number.": "Si tienes problemas para iniciar sesi\xF3n, podemos restablecer tu contrase\xF1a. Para ello, necesitaremos tu n\xFAmero de tel\xE9fono.",
    "If you're not sure if you have an account, or if you've forgotten your password, you can <0>try resetting your password</0>.": "Si no est\xE1s seguro de si tienes una cuenta o si has olvidado tu contrase\xF1a, puedes <0>intentar restablecerla</0>.",
    "Illinois": "Illinois",
    "Inadequate water pressure": "Presi\xF3n de Agua Inadecuada",
    "Inadequate/no super service": "Servicio de s\xFAper inadecuado",
    "Indiana": "Indiana",
    "Iowa": "Iowa",
    "Is this free?": "\xBFEs gratis?",
    "It doesn't seem like this property is required to register with HPD. You can learn about the City's registration requirements on <0>HPD's Property Management page</0>.": "Parece que esta propiedad no tiene que estar registrada con el HPD. Puedes aprender los requisitos de registro de la ciudad en la p\xE1gina <0>Gesti\xF3n de Propiedad de HPD</0>.",
    "It is encouraged that you call 311 to report housing complaints directly with the City. By calling, you will trigger a formal inspection process that may lead to official violations being issued.": "Se recomienda llamar al 311 para informar directamente a la ciudad sobre cualquier queja relacionada con la vivienda. Al llamar, se iniciar\xE1 un proceso de inspecci\xF3n formal que puede dar lugar a la emisi\xF3n de infracciones oficiales.",
    "It’s your first time here!": "\xA1Es la primera vez que est\xE1s aqu\xED!",
    "JustFix is a registered 501(c)(3) nonprofit organization.": "JustFix es una organizaci\xF3n registrada 501(c)(3) sin fines de lucro.",
    "JustFix's Learning Center": "Centro de Aprendizaje de JustFix",
    "Kansas": "Kansas",
    "Kentucky": "Kentucky",
    "Kitchen": "Cocina",
    "LA Tenant Action Center": "Centro de Acci\xF3n del Inquilino de LA",
    "Landlord address": "Direcci\xF3n de correo del due\xF1o de tu edificio",
    "Landlord name": "Nombre del due\xF1o de tu edificio",
    "Landlord/management company's email": "Direcci\xF3n de correo electr\xF3nico del due\xF1o o manager de tu edificio",
    "Landlord/management company's name": "Nombre del due\xF1o o manager de tu edificio",
    "Language:": "Idioma:",
    "Laundry room": "Lavanderia",
    "Lead-based paint": "Pintura a base de plomo",
    "Leaky faucet": "Grifo con fugas",
    "Learn about why we made this tool, who we are, and who our partners are.": "Aprenda por qu\xE9 hemos construido esta herramienta, qui\xE9nes somos, y qui\xE9nes son nuestros aliados.",
    "Learn about your rent": "Aprende Sobre Tu Alquiler",
    "Learn more": "Aprender m\xE1s",
    "Learn more about our mission on our website": "Obt\xE9n m\xE1s informaci\xF3n a cerca de nuestra misi\xF3n en nuestro sitio web (s\xF3lo en ingl\xE9s)",
    "Learn more about {label} leases": function (a) {
  return ["M\xE1s informaci\xF3n sobre ", a("label"), " arrendamientos"];
},
    "Legal first name": "Primer nombre legal",
    "Legal last name": "Apellido legal",
    "Legal name": "Nombre legal",
    "Legally vetted": "Verificado legalmente",
    "Let's get to know you.": "Conozc\xE1monos.",
    "Let's set you up with a new password, so you can easily login again.": "Configuremos una nueva contrase\xF1a, para que puedas volver f\xE1cilmente.",
    "Letter of Complaint": "Carta de Queja",
    "Living room": "Sala",
    "Log in": "Iniciar sesi\xF3n",
    "Log out": "Cerrar sesi\xF3n",
    "Looks like you're already logged in": "Parece ser que ya has iniciado tu sesi\xF3n",
    "Looks like you're not logged in": "Parece que no has iniciado ninguna sesi\xF3n",
    "Looks like you've been here before. Click \"Next\" to be taken to where you left off.": "Parece que ya estuviste aqu\xED antes. Haz clic en \"Continuar\" para seguir desde donde te quedaste.",
    "Loose floor": "Piso suelto",
    "Louisiana": "Luisiana",
    "Made with NYC ♥ by the team at <0>JustFix</0>": "Hecho en NYC con \u2665 por el equipo de <0>JustFix</0>",
    "Mail for me": "Enviar para mi",
    "Mail myself": "Enviar yo mismo",
    "Mailing address": "Direcci\xF3n postal",
    "Maine": "Maine",
    "Make sure to be thorough.": "Aseg\xFArate de ser minucioso.",
    "Market Rate": "Tasa de mercado",
    "Market rate tenants typically live in buildings of fewer than six (6) units, newer buildings, or formerly rent stabilized apartments that a landlord deregulated before 2019.": "Los inquilinos que pagan el precio de mercado suelen vivir en edificios de menos de seis (6) unidades, edificios m\xE1s nuevos o apartamentos que anteriormente ten\xEDan alquiler estabilizado y que el propietario desregul\xF3 antes de 2019.",
    "Maryland": "Maryland",
    "Massachusetts": "Massachusetts",
    "Mice": "Ratones",
    "Michigan": "Michigan",
    "Minnesota": "Minnesota",
    "Mississippi": "Misisipi",
    "Missouri": "Misuri",
    "Mold": "Moho",
    "Mold and Moisture": "Moho y humedad",
    "Mold on walls": "Muros Con Moho",
    "Montana": "Montana",
    "More actions": "M\xE1s acciones",
    "Must be at least 8 characters. Can't be all numbers.": "Debe tener por lo menos 8 letras. No se puede usar solo n\xFAmeros.",
    "NYCHA is under a court order to remediate problems with mold and moisture in their buildings. This includes peeling paint.": "NYCHA tiene la obligaci\xF3n judicial de solucionar los problemas de moho y humedad en sus edificios. Esto incluye la pintura descascarillada.",
    "NYCHA/Public Housing (includes RAD/PACT)": "NYCHA/Vivienda p\xFAblica (incluye RAD/PACT)",
    "Nebraska": "Nebraska",
    "Nevada": "Nevada",
    "New Hampshire": "Nuevo Hampshire",
    "New Jersey": "Nueva Jersey",
    "New Mexico": "Nuevo M\xE9xico",
    "New York": "Nueva York",
    "New York City has many forms of affordable housing. Some common types include Mitchell Lama, Project-Based Section 8 buildings (also known as HUD), LIHTC, HDFC rentals, and others.": "La ciudad de Nueva York cuenta con muchas formas de vivienda asequible. Algunos tipos comunes son Mitchell Lama, edificios del Proyecto Secci\xF3n 8 (tambi\xE9n conocidos como HUD), LIHTC, alquileres HDFC y otros.",
    "New York City has many kinds of housing. Learn more by ordering your rent history <0>here</0> or reading about <1>rent regulation</1>.": "La ciudad de Nueva York cuenta con muchos tipos de viviendas. Obt\xE9n m\xE1s informaci\xF3n solicitando tu historial de alquiler <0>aqu\xED</0> o leyendo sobre <1>la regulaci\xF3n de los alquileres.</1>",
    "New password": "Contrase\xF1a nueva",
    "Next": "Continuar",
    "No": "No",
    "No cold water": "Sin agua fr\xEDa",
    "No gas": "Sin gas",
    "No heat": "Sin calefacci\xF3n",
    "No hot water": "Sin agua caliente",
    "No issues reported": "No hay problemas reportados",
    "No registration found.": "No hay fecha de registro.",
    "No rent letter": "Sin carta de alquiler",
    "No rent receipts given": "No se dan recibos de alquiler",
    "No smoke detector": "Sin detector de humo",
    "North Carolina": "Carolina del Norte",
    "North Dakota": "Dakota del Norte",
    "Not enough": "Insuficiente",
    "Not sure": "No estoy seguro",
    "Now we just need your password. This is the same one you’ve used on JustFix or NoRent.": "Ahora solo necesitamos tu contrase\xF1a. Esta es la misma que usas en JustFix o NoRent.",
    "Ohio": "Ohio",
    "Oklahoma": "Oklahoma",
    "One issue reported": "Un problema reportado",
    "Oops! A network error occurred. Try again later.": "\xA1Vaya! Hubo un error en la red. Int\xE9ntalo m\xE1s tarde.",
    "Order rent history": "Pedir Historial de Renta",
    "Oregon": "Oreg\xF3n",
    "Other": "Otro",
    "Our Partners": "Nuestros aliados",
    "Our records have shown us a similar address. Would you like to proceed with this address:": "Nuestros registros han encontrado una direcci\xF3n similar. \xBFQuieres continuar con la direcci\xF3n siguiente?",
    "Our records tell us that this address is invalid.": "Nuestros registros indican que esta direcci\xF3n no es v\xE1lida.",
    "Our records tell us that this address is undeliverable.": "Nuestros registros indican que no se puede enviar correo a esta direcci\xF3n.",
    "Outlets not working": "Tomas de corriente no funcionan",
    "Painting overdue (3 years)": "Pintura Atrasada (cada 3 a\xF1os)",
    "Password": "Contrase\xF1a",
    "Peeling paint": "Pintura Se Descama",
    "Peeling/flaking paint": "Pintura Escamada/Pelada",
    "Pennsylvania": "Pensilvania",
    "Phone number": "N\xFAmero de tel\xE9fono",
    "Pipes leaking": "Tuber\xEDas con fugas",
    "Please agree to our terms and conditions": "Por favor, acepta nuestros t\xE9rminos y condiciones",
    "Please confirm your password": "Por favor confirma tu contrase\xF1a",
    "Please enter your landlord's name and contact information below. You can find this information on your lease and/or rent receipts.": "Por favor, proporciona el nombre del due\xF1o de tu edificio as\xED como su informaci\xF3n de contacto. Puedes encontrar esta informaci\xF3n en tu contrato de arrendamiento y/o tus recibos de alquiler.",
    "Please go room-by-room and select all of the issues that you are experiencing.": "Por favor, vaya habitaci\xF3n por habitaci\xF3n y seleccione todos los problemas que est\xE1 experimentando.",
    "Please use a number that can receive text messages.": "Por favor, usa un n\xFAmero que pueda recibir mensajes de texto.",
    "Preferred first name": "Nombre de preferencia",
    "Preferred first name (optional)": "Nombre preferido (opcional)",
    "Previous attempts to get help": "Intentos previos para obtener ayuda",
    "Previous attempts to get official help": "Intentos previos para obtener ayuda oficial",
    "Privacy Policy": "Pol\xEDtica de Privacidad",
    "Proceed with caution.": "Proceda con precauci\xF3n.",
    "Puerto Rico": "Puerto Rico",
    "Radiators/risers not working": "Radiadores/tubos de subida no funcionan",
    "Rats": "Ratas",
    "Rats/mice": "Ratas/ratones",
    "Recommended actions": "Acciones recomendadas",
    "Refrigerator not working": "Refrigerador no funciona",
    "Regards,": "Atentamente,",
    "Rent Controlled": "Alquiler controlado",
    "Rent Stabilized": "Renta Estabilizada",
    "Rent receipts incomplete": "Recibos de Alquiler Incompletos",
    "Rent stabilized": "Renta Estabilizada",
    "Request repairs from your landlord": "Solicitar arreglos del due\xF1o de tu edificio",
    "Research your landlord": "Investiga al due\xF1o de tu edificio",
    "Reset your password": "Cambia tu contrase\xF1a",
    "Results for {0}": function (a) {
  return ["Resultados para \"", a("0"), "\""];
},
    "Retaliation is <0>illegal</0> and all New Yorkers are <1>entitled to repairs</1> but, if you use this tool, your landlord could retaliate by raising the rent or sending a termination notice once your lease ends.": "Las represalias son <0>ilegales</0> y todos los neoyorquinos tienen <1>derecho a que se realicen reparaciones</1>, pero, si utilizas esta herramienta, tu arrendador podr\xEDa tomar represalias aumentando el alquiler o envi\xE1ndote una notificaci\xF3n de rescisi\xF3n una vez que finalice tu contrato de alquiler.",
    "Rhode Island": "Rhode Island",
    "Right to Privacy (CA)": "Derecho a la Privacidad (CA)",
    "Rodent infestation (mice, rats, ... )": "Infestaci\xF3n de roedores (ratones, ratas, ... )",
    "Rusty water": "Agua Oxidada",
    "Save": "Guardar",
    "Search address": "Direcci\xF3n de b\xFAsqueda",
    "See more FAQs": "Ver todas las preguntas frecuentes",
    "Select your issues": "Seleccione sus problemas",
    "Select your issues.": "Seleccione sus problemas.",
    "Send a letter of complaint": "Enviar una carta de queja",
    "Send code": "Enviar c\xF3digo",
    "Set up an account": "Configura tu cuenta",
    "Set your new password": "Establece tu nueva contrase\xF1a",
    "Set your password": "Establece tu contrase\xF1a",
    "Share this tool": "Compartir esta herramienta",
    "Shower": "Ducha",
    "Shower: drain stoppage": "Ducha: desag\xFCe atascado",
    "Shower: leaky shower head": "Ducha: alcachofa de ducha rota",
    "Shower: low water pressure": "Ducha: baja presi\xF3n de agua",
    "Shower: mold on walls": "Ducha: moho sobre las paredes",
    "Shower: not working": "Ducha: no funciona",
    "Shower: wall tiles cracked": "Ducha: baldosas agrietadas",
    "Shower: wall tiles missing": "Ducha: faltan baldosas",
    "Sign back in": "Vuelve a iniciar sesi\xF3n",
    "Sign in": "Iniciar sesi\xF3n",
    "Sign out": "Cerrar sesi\xF3n",
    "Sign up or log in to your account to access our tool.": "Reg\xEDstrate o inicia una sesi\xF3n en tu cuenta para acceder a nuestra herramienta.",
    "Signed out": "Has cerrado sesi\xF3n",
    "Signed,": "Firmado,",
    "Sink": "Lava manos",
    "Sink: cracked sink": "Lavabo: agrietado",
    "Sink: drain stoppage": "Lavabo: desag\xFCe atascado",
    "Sink: faucets not installed": "Lavabo: sin grifo",
    "Sink: faucets not working": "Lavabo: grifo no funciona",
    "Sink: leaky faucet": "Lavabo: grifo con fugas",
    "Sink: low water pressure": "Lavabo: baja presi\xF3n de agua",
    "Sink: pipes leaking": "Lavabo: tuber\xEDas con fugas",
    "Smoke detector not working": "Detector de humo no funciona",
    "Smoke or carbon monoxide detector": "Detectores de humos y mon\xF3xido de carbono",
    "Sorry, the page you are looking for doesn't seem to exist.": "Lo sentimos, la p\xE1gina que est\xE1s buscando no existe.",
    "Sorry, we don't recognize the address you entered.": "Lo sentimos, no reconocemos la direcci\xF3n que has introducido.",
    "South Carolina": "Carolina del Sur",
    "South Dakota": "Dakota del Sur",
    "Start": "Iniciar",
    "Start a legal case for repairs and/or harassment": "Empieza un caso legal por arreglos y/o acoso",
    "State": "Estado",
    "Step {0} of {1}": function (a) {
  return ["Paso ", a("0"), " de ", a("1")];
},
    "Stove not working": "Estufa no funciona",
    "Strategic Actions for a Just Economy": "Strategic Actions for a Just Economy",
    "Street address": "Direcci\xF3n",
    "Street address (include unit/suite/floor/apt #)": "Direcci\xF3n (incluye unidad/suite/piso/apt #)",
    "Subject: {0}": function (a) {
  return ["Tema: ", a("0")];
},
    "Take action": "Toma acci\xF3n",
    "Tennessee": "Tennessee",
    "Terms of Use": "T\xE9rminos de Uso",
    "Texas": "Tejas",
    "The majority of your landlord's properties are concentrated in {0}.": function (a) {
  return ["La mayor\xEDa de las propiedades del due\xF1o de tu edificio se concentran en ", a("0"), "."];
},
    "The name used in letters to your landlord and legal documents": "El nombre que usas en las cartas al propietario y en documentos legales",
    "The name you'd like to be called.": "Nombre que te gusta que te llamen.",
    "The webpage that you want to access is only available in English.": "La p\xE1gina web a la que quieres acceder solo est\xE1 disponible en ingl\xE9s.",
    "There {0, plural, one {is one unit} other {are # units}} in your building.": function (a) {
  return ["Hay ", a("0", "plural", {
    one: "una unidad",
    other: ["#", " unidades"]
  }), " en tu edificio."];
},
    "Think your apartment may be rent-stabilized? Request its official records.": "\xBFCrees que tu apartamento puede ser de renta estabilizada? Solicita el registro oficial.",
    "This <0>issue checklist</0> will be sent to your landlord.": "Esta <0>lista de verificaci\xF3n de problemas</0> se enviar\xE1 a tu arrendador.",
    "This building is owned by the <0>NYC Housing Authority (NYCHA)</0>.": "Este edificio es propiedad de la <0>NYC Housing Authority (NYCHA)</0>.",
    "This information seems wrong. Can I change it?": "Esta informaci\xF3n parece incorrecta. \xBFPuedo cambiarla?",
    "This is a rare kind of housing! Buildings that had three or more residential units before February 1, 1947, where the tenant or immediate family member has been continuously living in the apartment since July 1, 1971.": "\xA1Este es un tipo de vivienda poco com\xFAn! Edificios que ten\xEDan tres o m\xE1s unidades residenciales antes del 1 de febrero de 1947, en los que el inquilino o un familiar directo ha vivido de forma continuada desde el 1 de julio de 1971.",
    "This is optional.": "Esto es opcional.",
    "This is your landlord’s information as registered with the <0>NYC Department of Housing and Preservation (HPD)</0>. This may be different than where you send your rent checks.": "Esta es la informaci\xF3n del due\xF1o de tu edificio seg\xFAn los registros del <0>Departamento de Preservaci\xF3n de la Vivienda (HPD por sus siglas en ingl\xE9s)</0>. Puede que sea distinta de donde env\xEDas tu cheque de renta.",
    "To begin the password reset process, we'll text you a verification code.": "Para restablecer tu contrase\xF1a, te enviaremos un c\xF3digo de verificaci\xF3n.",
    "To:": "A:",
    "Toilet leaking": "Inodoro con Fugas",
    "Toilet not working": "Inodoro No Funciona",
    "Trash cans": "Botes de basura",
    "USPS Tracking #:": "N\xFAmero de Seguimiento USPS:",
    "Unit/apt/lot/suite number": "N\xFAmero de apartamento/unidad/lote/suite",
    "Unrecognized address": "Direcci\xF3n no reconocida",
    "Unsafe/broken stairs and/or railing": "Escaleras y/o barandales inseguros/rotos",
    "Used for logging in to your account": "Se usa para ingresar a tu cuenta",
    "Utah": "Utah",
    "Utilities": "Utilidades",
    "Utilities shut off (water, gas, ... )": "Corte de los servicios p\xFAblicos (agua, gas, ... )",
    "Vacate order issued": "Orden de vac\xEDo emitida",
    "Verification code": "C\xF3digo de verificaci\xF3n",
    "Verify your phone number": "Verifica tu n\xFAmero de tel\xE9fono",
    "Vermont": "Vermont",
    "Virginia": "Virginia",
    "Visit Who Owns What": "Visita Qui\xE9n Es El Due\xF1o",
    "Want to read more about your rights?": "\xBFQuieres leer m\xE1s sobre tus derechos?",
    "Washing machine not working": "Lavadora no funciona",
    "Washington": "Washington",
    "Water": "Agua",
    "Water damage": "Da\xF1o Por Agua",
    "Water leak": "Fuga de agua",
    "We'll provide this information again after you complete your letter.": "Te proporcionaremos esta informaci\xF3n de nuevo una vez que hayas completado tu carta.",
    "We've just sent you a text message containing a verification code. Please enter it below.": "Acabamos de enviarte un mensaje de texto que contiene un c\xF3digo de verificaci\xF3n. Por favor, introd\xFAcelo abajo.",
    "Weak electrical current": "Baja Corriente El\xE9ctrica",
    "Welcome back!": "\xA1Hola de nuevo!",
    "West Virginia": "Virginia Occidental",
    "What contact information do you have for your landlord or building management? <0>We recommend choosing both if you have them.</0>": "\xBFQu\xE9 informaci\xF3n de contacto tienes del due\xF1o o manager de tu edificio? <0>Sugerimos que elijas las dos opciones si las tienes.</0>",
    "What happens next?": "\xBFY ahora qu\xE9?",
    "What is Affordable Housing (other than rent stabilized)?": "\xBFQu\xE9 es una vivienda asequible (aparte de las viviendas con alquiler estabilizado)?",
    "What is Market Rate Housing?": "\xBFQu\xE9 es una vivienda a precio de mercado?",
    "What is NYCHA, Public Housing, and RAD/PACT?": "\xBFQu\xE9 son NYCHA, vivienda p\xFAblica y RAD/PACT?",
    "What is Rent Controlled Housing?": "\xBFQu\xE9 es una vivienda de alquiler controlado?",
    "What is Rent Stabilized Housing?": "\xBFQu\xE9 es una vivienda de alquiler estabilizado?",
    "What is your borough?": "\xBFCu\xE1l es tu municipalidad?",
    "What type of housing do you live in?": "\xBFEn qu\xE9 tipo de vivienda vives?",
    "Where do I find this information?": "\xBFD\xF3nde encuentro esta informaci\xF3n?",
    "Where do you live?": "\xBFD\xF3nde vives?",
    "Where we will send you your documents.": "Donde te enviaremos tus documentos.",
    "Whether it's your first time here, or you're a returning user, let's start with your number.": "Empecemos con tu n\xFAmero de tel\xE9fono, ya sea tu primera vez aqu\xED, o est\xE9s de vuelta.",
    "Who we are": "Qui\xE9nes somos",
    "Why do I need to create an account?": "\xBFPor qu\xE9 necesito crear una cuenta?",
    "Why do you need my address?": "\xBFPor qu\xE9 necesita mi direcci\xF3n?",
    "Why do you need this information?": "\xBFPor qu\xE9 necesit\xE1is esta informaci\xF3n?",
    "Why we made this": "Por qu\xE9 hemos creado esta herramienta",
    "Window frame defective": "Marco de ventana defectuoso",
    "Window glass broken": "Cristal de ventana roto",
    "Window guards missing": "Faltan Protectores de Ventana",
    "Wisconsin": "Wisconsin",
    "Wyoming": "Wyoming",
    "Yes": "Si",
    "Yes, JustFix can text me to follow up about my housing issues.": "S\xED, JustFix puede enviarme mensajes de texto para hacer un seguimiento de mis problemas de vivienda.",
    "Yes, Sign Out": "S\xED, cerrar sesi\xF3n",
    "Yes, sign out": "S\xED, cerrar sesi\xF3n",
    "You already have an account": "Ya tienes una cuenta",
    "You are now signed out.": "Se ha cerrado la sesi\xF3n.",
    "You can also track the delivery of your letter using USPS Tracking:": "Tambi\xE9n puede seguir la entrega de su carta usando USPS Tracking:",
    "You can contact Strategic Actions for a Just Economy (SAJE) - a 501c3 non-profit organization in South Los Angeles.": "Puedes contactar Acciones Estrat\xE9gicas para una Econom\xEDa Justa (SAJE) - una organizaci\xF3n sin fines de lucro 501c3 en el sur de Los Angeles.",
    "You can now <0>log in with your new password</0>.": "Ahora puedes <0>iniciar sesi\xF3n con tu nueva contrase\xF1a</0>.",
    "You can use the form below if you'd like us to email your {noun} to up to {max} addresses.": function (a) {
  return ["Puedes utilizar el siguiente formulario si deseas que enviemos tu ", a("noun"), " por correo electr\xF3nico a un m\xE1ximo de ", a("max"), " direcciones."];
},
    "You have chosen to overwrite the landlord recommended by JustFix. Please provide your own details below, or <0>use the recommended landlord \"{0}\"</0>.": function (a) {
  return ["Has elegido sustituir la informaci\xF3n recomendada por JustFix sobre el due\xF1o de tu edificio. Por favor proporciona tu propia informaci\xF3n a continuaci\xF3n, o <0>usa el due\xF1o recomendado\"", a("0"), "\"</0>."];
},
    "You may already have a JustFix account.": "Es posible que ya tengas una cuenta de JustFix.",
    "Your Letter Is Ready To Send!": "\xA1Tu carta est\xE1 lista para enviar!",
    "Your address": "Tu direcci\xF3n",
    "Your apartment may be rent stabilized.": "Tu apartamento es de renta estabilizada.",
    "Your building had {0, plural, one {one rent stabilized unit} other {# rent stabilized units}} in {1}.": function (a) {
  return ["Tu edificio ten\xEDa ", a("0", "plural", {
    one: "una unidad de alquiler estabilizado",
    other: ["#", " unidades de renta estabilizada"]
  }), " en el ", a("1"), "."];
},
    "Your building was built in {0} or earlier.": function (a) {
  return ["Tu edificio fue construido en ", a("0"), " o antes."];
},
    "Your contact information": "Su informaci\xF3n de contacto",
    "Your email address": "Tu direcci\xF3n de correo electr\xF3nico",
    "Your landlord is associated with {0, plural, one {one building} other {# buildings}} and {1, plural, one {one unit.} other {# units.}}": function (a) {
  return ["El due\xF1o de su edificio est\xE1 asociado con ", a("0", "plural", {
    one: "un edificio",
    other: ["#", " edificios"]
  }), " y ", a("1", "plural", {
    one: "una unidad.",
    other: ["#", " unidades."]
  })];
},
    "Your landlord is associated with {buildings, plural, one {one building} other {# buildings}}.": function (a) {
  return ["El proprietario de tu edificio est\xE1 asociado con ", a("buildings", "plural", {
    one: "un edificio",
    other: ["#", " edificios"]
  }), "."];
},
    "Your landlord may be breaking the law!": "\xA1Puede que el proprietario de tu edificio est\xE9 violando la ley!",
    "Your landlord might own other buildings, too.": "Puede que el propietario de tu edificio tambi\xE9n posea otros edificios.",
    "Your landlord or management company's address": "La direcci\xF3n del due\xF1o o manager de tu edificio",
    "Your landlord or management company's email": "La direcci\xF3n de correo electr\xF3nico del due\xF1o o manager de tu edificio",
    "Your landlord or management company's information": "Los datos del due\xF1o o manager de tu edificio",
    "Your letter was sent on {0}.": function (a) {
  return ["Tu carta fue enviada el ", a("0"), "."];
},
    "Your password has been reset!": "\xA1Tu contrase\xF1a ha sido restablecida!",
    "Your phone number": "Tu n\xFAmero de tel\xE9fono",
    "Your privacy is very important to us": "Tu privacidad es importante para nosotros",
    "Your privacy is very important to us. Everything on JustFix is secure.": "Su privacidad es muy importante para nosotros. Todo en JustFix es seguro.",
    "Your privacy is very important to us. Everything on JustFix is secure. <0>Click here to learn more<1> about our privacy policy</1></0>.": "Tu privacidad es muy importante para nosotros. Todo en JustFix es seguro. <0>Haz clic aqu\xED para obtener m\xE1s informaci\xF3n<1> sobre nuestra pol\xEDtica de privacidad</1></0>.",
    "Your residence": "Tu hogar",
    "Your rights vary depending on what type of housing you live in.": "Tus derechos var\xEDan en funci\xF3n del tipo de vivienda en la que vivas.",
    "Zip code": "C\xF3digo postal",
    "justfix.DdoMayNeedHpdRegistration": "Parece que este edificio deba estar registrado con el HPD. Los proprietarios que no registren sus propiedades correctamente incurren multas y no tienen el derecho de llevar a los inquilinos a la corte por no pagar el alquiler. Puedes encontrar m\xE1s informaci\xF3n en la p\xE1gina <0>Gesti\xF3n de Propiedades de HPD</0>",
    "justfix.commonWarningAboutChangingLandlordDetails1": "Si recibes documentos relacionados con el alquiler desde una direcci\xF3n diferente, o si el due\xF1o de tu edificio te ha dado instrucciones de usar una direcci\xF3n diferente para vuestra correspondencia, puedes <0>proporcionar tus propios datos.</0> Sin embargo, s\xF3lo debes usar una direcci\xF3n distinta a la que te sugerimos si tienes la certeza absoluta de que es correcta\u2014es m\xE1s seguro usar la direcci\xF3n oficial que el due\xF1o de tu edificio ha registrado con la ciudad.",
    "justfix.ddoEhpaDeactivatedMessage": "A partir de junio de 2021, La Corte de Vivienda ha impedido que los inquilinos demanden a sus due\xF1os a trav\xE9s de la herramienta HP Action de JustFix. Para aprender c\xF3mo presentar una Acci\xF3n de HP ahora, lee nuestra <0>art\xEDculo de Medium</0>. Para aprender m\xE1s acera de Acciones de HP y encontrar una lista de proveedores legales, visita <1>Housing Court Answers</1>.",
    "justfix.ddoLocCovidMessage": "\xBFEl due\xF1o de tu edificio no contesta? \xA1Puedes tomar acci\xF3n gratis para pedir arreglos! Debido a la crisis de salud por el Covid-19, te recomendamos que s\xF3lo pidas arreglos en caso de emergencia, para que puedas mantener la salud limitando cu\xE1ntas personas entran a tu hogar.",
    "justfix.howIsPersonalInfoProtectedV2": "Todo en JustFix es seguro. No usamos tu informaci\xF3n personal con fines de lucro ni la vendemos a terceros. Ve nuestra <0/>.",
    "justfix.legalDisclaimer": function (a) {
  return ["Aviso: La informaci\xF3n en ", a("website"), " no constituye asesoramiento jur\xEDdico y no debe ser utilizado como sustituto del asesoramiento de un abogado cualificado para asesorar sobre cuestiones jur\xEDdicas relativas a la vivienda. Si lo necesitas, podemos ayudar a dirigirte a servicios legales gratuitos."];
},
    "justfix.privacyInfoModalTextV2": "<0>Tu privacidad es muy importante para nosotros. Aqu\xED hay algunas cosas importantes que debes saber: </0><1><2>Tu informaci\xF3n personal est\xE1 segura.</2><3>No usamos tus datos personales con fines de lucro ni los vendemos a terceros.</3><4>Usamos tu direcci\xF3n para encontrar informaci\xF3n del propietario y de tu edificio.</4></1><5>Nuestra Pol\xEDtica de privacidad permite compartir datos an\xF3nimos con organismos aprobados de abogac\xEDa para inquilinos exclusivamente para ayudar a impulsar nuestra misi\xF3n de los derechos de inquilinos. La Pol\xEDtica de privacidad contiene informaci\xF3n con respecto a datos recopilamos, c\xF3mo los usamos y las opciones que tienes en cuanto a tu informaci\xF3n personal. Si te gustar\xEDa leer m\xE1s, por favor repasa nuestra <6/> y <7/> completa.</5>",
    "justfix.whyIsAccountNeeded": "Una cuenta te permite crear, enviar y acceder de forma segura a las cartas que te ayuden a ejercer tus derechos de inquilino.",
    "justfix.whyIsPhoneNumberNeeded": "Utilizaremos esta informaci\xF3n para:<0><1>Acceder a tu cuenta actual</1><2>Comprobar si coincide con una cuenta preexistente </2><3>Abrirte una cuenta nueva.</3></0><4/>Una cuenta te permitir\xE1 volver a nuestras herramientas en cualquier punto del proceso sin tener que empezar desde el principio, descargar cualquier documentos que hayas completado, y recibir notificaciones sobre cambios relevantes a pol\xEDticas que te afecten.",
    "norent.sajeBlockQuote": "Desde 1996, SAJE ha sido una fuerza para la justicia econ\xF3mica en nuestra comunidad, centr\xE1ndose en los derechos de los inquilinos, la vivienda saludable y el desarrollo equitativo. Creemos que el destino de los vecindarios de la ciudad debe ser decidido por quienes viven all\xED, y nos reunimos con otras organizaciones para garantizar que esto ocurra de manera justa, replicable y sostenible. La vivienda es un derecho humano.",
    "norent.sajePhoneCalls": "Acciones Estrat\xE9gicas para una Econom\xEDa Justa (SAJE) est\xE1 disponible para llamadas telef\xF3nicas en el (213) 745-9961, de lunes a viernes de 10:00am-6:00pm.",
    "{0} (in English)": function (a) {
  return [a("0"), " (en ingl\xE9s)"];
},
    "{actionLabel} for {label}": function (a) {
  return [a("actionLabel"), " para ", a("label")];
},
    "{count} issues reported": function (a) {
  return [a("count"), " problemas reportados"];
},
    "{label} (optional)": function (a) {
  return [a("label"), " (Opcional)"];
},
    "{label} - Issue checklist": function (a) {
  return [a("label"), " - Lista de problemas"];
},
    "{label} issues": function (a) {
  return [a("label"), " problemas"];
},
    "{remaining, plural, one {1 character remaining} other {# characters remaining}}": function (a) {
  return [a("remaining", "plural", {
    one: "queda s\xF3lo 1 car\xE1cter",
    other: ["quedan ", "#", " caracteres"]
  })];
},
    "{title} ({issueLabel})": function (a) {
  return [a("title"), " (", a("issueLabel"), ")"];
},
  },
};